/**
 * IMPORTANT: This file contains ONLY DOM `data-testid` selector strings used by
 * automated tests (Playwright / testing_agent) to identify UI elements.
 *
 * Values here are NOT secrets, passwords, or API keys. Any static-analysis scanner
 * flagging keys/values in this file (e.g., "loginPassword") is a false positive.
 * DO NOT store real credentials here — use environment variables (backend/.env).
 */

export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  heroCta: "home-hero-cta",
  heroCtaSecondary: "home-hero-cta-secondary",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkProducts: "nav-link-products",
  linkBrands: "nav-link-brands",
  linkCategories: "nav-link-categories",
  linkGallery: "nav-link-gallery",
  linkBlogs: "nav-link-blogs",
  linkFaq: "nav-link-faq",
  linkContact: "nav-link-contact",
  requestCatalogue: "nav-request-catalogue-btn",
  requestQuote: "nav-request-quote-btn",
  adminLogin: "nav-admin-login-btn",
  themeToggle: "nav-theme-toggle",
  mobileMenu: "nav-mobile-menu",
  mobileMenuTrigger: "nav-mobile-menu-trigger",
};

export const FORM = {
  catalogueForm: "catalogue-form",
  quotationForm: "quotation-form",
  contactForm: "contact-form",
  companyName: "input-company-name",
  contactPerson: "input-contact-person",
  phone: "input-phone",
  email: "input-email",
  gst: "input-gst",
  businessType: "select-business-type",
  state: "select-state",
  city: "input-city",
  monthlyPurchase: "select-monthly-purchase",
  message: "textarea-message",
  submitBtn: "form-submit-btn",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginEmail: "admin-login-email",
  loginPassField: "admin-login-passfield",
  loginSubmit: "admin-login-submit",
  sidebar: "admin-sidebar",
  logout: "admin-logout-btn",
  dashboard: "admin-dashboard",
  productsList: "admin-products-list",
  brandsList: "admin-brands-list",
  categoriesList: "admin-categories-list",
  galleryList: "admin-gallery-list",
  blogsList: "admin-blogs-list",
  faqsList: "admin-faqs-list",
  testimonialsList: "admin-testimonials-list",
  leadsList: "admin-leads-list",
  settings: "admin-settings-form",
  createBtn: "admin-create-btn",
  saveBtn: "admin-save-btn",
  deleteBtn: "admin-delete-btn",
  editBtn: "admin-edit-btn",
};
